import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import Process from "@/components/Process";
import About from "@/components/About";
import VideoSection from "@/components/VideoSection";
import Faq from "@/components/Faq";
import EnquiryForm from "@/components/EnquiryForm";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Catalog from "@/pages/Catalog";
import Account from "@/pages/Account";

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen grid place-items-center bg-ink text-paper font-mono text-sm">
          <button
            data-testid="error-reload-button"
            className="underline underline-offset-4"
            onClick={() => (window.location.href = "/")}
          >
            Something went wrong — reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function Home() {
  return (
    <div className="grain bg-ink text-paper font-body overflow-x-clip">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Pricing />
        <Process />
        <About />
        <VideoSection />
        <Faq />
        <EnquiryForm />
      </main>
      <Footer />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Google OAuth callback: detect the session_id fragment synchronously during
  // render (not in an effect) so it is processed before any /auth/me check.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/catalog" element={<Catalog />} />
      <Route path="/account" element={<Account />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll />
        <AppRouter />
        <Toaster position="bottom-right" theme="dark" richColors />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
